/**
 * @generated SignedSource<<b028166e8abd0041878fef7b229ea160>>
 * @relayHash 1626974867006844655b351aa2d7a5d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a3d33871208727c3645e90342c79b69a77d9d1fa18fcc933c496314171b5cf1b

import type { ConcreteRequest } from 'relay-runtime';
export type ActionsAuthType = "THREE_LEGGED" | "TWO_LEGGED" | "%future added value";
export type ActionsExecuteActionInput = {
  cloudId?: string | null;
  inputs?: AGG$JSON | null;
  meta?: AGG$JSON | null;
  target?: ActionsExecuteTargetInput | null;
};
export type ActionsExecuteTargetInput = {
  ari?: string | null;
  ids?: AGG$JSON | null;
  url?: string | null;
};
export type ActionsExecuteActionFilter = {
  actionAri?: string | null;
  actionId?: string | null;
  authType?: ReadonlyArray<ActionsAuthType | null> | null;
  extensionAri?: string | null;
  integrationKey?: string | null;
  oauthClientId?: string | null;
  providerAri?: string | null;
  providerId?: string | null;
};
export type useInferredProjectContextMutation$variables = {
  actionInput: ActionsExecuteActionInput;
  filter: ActionsExecuteActionFilter;
};
export type useInferredProjectContextMutation$data = {
  readonly actions: {
    readonly execute: {
      readonly outputs: AGG$JSON | null;
      readonly status: number | null;
    } | null;
  } | null;
};
export type useInferredProjectContextMutation = {
  response: useInferredProjectContextMutation$data;
  variables: useInferredProjectContextMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "actionInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "concreteType": "ActionsMutation",
    "kind": "LinkedField",
    "name": "actions",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "actionInput",
            "variableName": "actionInput"
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          }
        ],
        "concreteType": "ActionsExecuteResponse",
        "kind": "LinkedField",
        "name": "execute",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "outputs"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useInferredProjectContextMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useInferredProjectContextMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "a3d33871208727c3645e90342c79b69a77d9d1fa18fcc933c496314171b5cf1b",
    "metadata": {},
    "name": "useInferredProjectContextMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "43d35e019c6ddf99aa5f93082bd12b49";

export default node;
